import { connect } from 'react-redux';
import { cleanCompare } from '../actions/compare';
import Header from '../views/Header';

const mapStateToProps = function (store) {
  return {
    compare: store.compareState.compare,
  };
};

const mapDispatchToProps = function (dispatch) {
  return {
    cleanCompare: (item) => dispatch(cleanCompare(item)),
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(Header);
